import useShowAfter from './useShowAfter';

/**
 * Hook canônico pra timing do spinner localizado (REDLINE-loading.md §2 + §6).
 *
 * <p>Wrapper de `useShowAfter(200, active, 400)`:
 * <ul>
 *   <li>Grace period 200ms — spinner não aparece em ações que resolvem
 *   antes disso (Nielsen: threshold anti-flicker clássico de spinner).
 *   <li>Duração mínima 400ms — se o spinner aparecer, permanece pelo menos
 *   400ms mesmo que a ação termine rápido depois. Evita flicker "apareceu
 *   e sumiu em 50ms".
 * </ul>
 *
 * <p><b>IMPORTANTE:</b> este hook controla APENAS a parte VISUAL (spinner +
 * gerúndio + opacity). O `disabled` do botão deve continuar amarrado ao
 * state real (`saving`/`submitting`/`isExporting`) — se esperar 200ms pra
 * desabilitar, o double-click passa entre o clique e o gate ficar ativo.
 *
 * <p>Uso:
 * ```jsx
 * const showSpinner = useSpinner(submitting);
 * return (
 *   <Button disabled={submitting} style={{ opacity: showSpinner ? 0.72 : 1 }}>
 *     {showSpinner && <span className="spin sm onteal"/>}
 *     {showSpinner ? 'Filtrando…' : 'Filtrar'}
 *   </Button>
 * );
 * ```
 *
 * <p><b>Diferença pro `useSkeleton`</b>: skeleton usa 400/400 (Material Design
 * threshold, skeleton é visualmente mais invasivo). Spinner usa 200/400
 * (Nielsen threshold, spinner é discreto). Numbers vêm da distinção
 * histórica entre "spinner anti-flicker" e "skeleton anti-flicker".
 */
export default function useSpinner(active) {
	return useShowAfter(200, active, 400);
}
